<div class="card card-box mb-5 d-flex flex-row flex-wrap justify-content-center">
    <div class="py-4 px-5 d-flex align-items-center">
        <i-feather class="d-50 text-dark opacity-2 mr-3 line-height-1" name="bell"></i-feather>
        <div>
            <span class="d-block opacity-7">Expenses</span>
            <span class="font-weight-bold font-size-lg text-danger"><small class="opacity-6 pr-1">$</small>1,693</span>
        </div>
    </div>
    <div class="py-4 px-5 d-flex align-items-center">
        <i-feather class="d-50 text-dark opacity-2 mr-3 line-height-1" name="settings"></i-feather>
        <div>
            <span class="d-block opacity-7">Revenue</span>
            <span class="font-weight-bold font-size-lg"><small class="opacity-6 pr-1">$</small>54,233</span>
        </div>
    </div>
    <div class="py-4 px-5 d-flex align-items-center">
        <i-feather class="d-50 text-dark opacity-2 mr-3 line-height-1" name="grid"></i-feather>
        <div>
            <span class="d-block opacity-7">Users</span>
            <span class="font-weight-bold font-size-lg"><small class="opacity-6 pr-1">$</small>658</span>
        </div>
    </div>
    <div class="py-4 px-5 d-flex align-items-center">
        <i-feather class="d-50 text-dark opacity-2 mr-3 line-height-1" name="life-buoy"></i-feather>
        <div>
            <span class="d-block opacity-7">Sales</span>
            <span class="font-weight-bold font-size-lg text-success"><small class="opacity-6 pr-1">$</small>385</span>
        </div>
    </div>
    <div class="py-4 px-5 d-flex align-items-center">
        <i-feather class="d-50 text-dark opacity-2 mr-3 line-height-1" name="briefcase"></i-feather>
        <div>
            <span class="d-block opacity-7">Income</span>
            <span class="font-weight-bold font-size-lg"><small class="opacity-6 pr-1">$</small>3,217</span>
        </div>
    </div>
</div>